var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex min-vh-100 align-items-center text-center"},[_c('CContainer',[_c('h1',[_vm._v(" Oops! 403 "),_c('br'),_vm._v(" Access Not Granted. ")]),_c('CButton',{staticClass:"mt-4",attrs:{"to":{
				path: '/'
			},"color":"secondary"}},[_vm._v(" Return to Home ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }